/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OptionBanksIndexResponse } from '../models/OptionBanksIndexResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class OptionBanksService {

    /**
     * account option banks
     * Get option banks for account
     * @returns OptionBanksIndexResponse successful
     * @throws ApiError
     */
    public static getInternalApiOptionBanksOptionBanks(): CancelablePromise<OptionBanksIndexResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/option_banks/option_banks',
            errors: {
                401: `unauthorized`,
            },
        });
    }

    /**
     * Reports whether the option bank synced from a WX dataset is used by a question
     * @param authorization Bearer WX JWT. The account API key is refused.
     * @param wxDatasetUuid Uuid of the WX Option Bank dataset
     * @returns any usage reported
     * @throws ApiError
     */
    public static getInternalApiWxOptionBanksUsage(
        authorization: string,
        wxDatasetUuid: string,
    ): CancelablePromise<{
        linked: boolean;
        question_count: number;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/wx/option_banks/usage',
            headers: {
                'Authorization': authorization,
            },
            query: {
                'wx_dataset_uuid': wxDatasetUuid,
            },
            errors: {
                400: `malformed wx_dataset_uuid`,
            },
        });
    }

}